module.exports = __webpack_public_path__ + "media/21.ba43f2e3.mp3";